import { Utils } from "@/plugins/utils";
import router from '@/router';

export default {
	namespaced: true,
	state: {
		lstIn6: [],
		in6: null,
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 20,
		search: "",
		hasNext: false,
		lastUpdatedRegister: null
	},
	getters: {
		getUpdate(state) {
			return state.update
		},
		getIn6(state) {
			return state.in6
		},
		getIn6fabr(state) {
			return state.in6.in6fabr
		},
		getSearch(state) {
			return state.search
		},
		getItemsPerPage(state) {
			return state.itemsPerPage
		},
	},
	mutations: {
		set(state, in6) {
			state.in6 = in6
			if (in6)
				state.update = true
		},
		initForm(state) {
			state.insert = false
			state.update = false
			state.in6 = null
		},
		setParamsDataTable(state, payload) {
			state.lstIn6 = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
		setLoading(state, loading) {
			state.loading = loading
		},
		setIn6(state, in6) {
			state.in6 = in6
		},
		setLstIn6(state, lstIn6) {
			state.lstIn6 = lstIn6
		},
		setHasNext(state, hasNext) {
			state.hasNext = hasNext
		},
		setSearch(state, search) {
			state.search = search
		},
		setLastUpdatedRegister(state, lastUpdatedRegister) {
			state.lastUpdatedRegister = lastUpdatedRegister
		},
	},
	actions: {
		initForm({ commit }) {
			commit("initForm")
		},
		async find({ commit, dispatch }, in6fabr) {
			commit("setLoading", true)
			commit("initForm")
			await this._vm.$axios.get(`/Stock/Manufacturer/Find/${in6fabr}`)
				.then(response => {
					let in6 = Utils.ValidateAxiosResponse(response.data);
					commit("set", in6)
				})
				.catch((error) => {
					dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message
					}, { root: true })
				});
			commit("setLoading", false)
		},
		async save({ getters, dispatch }) {
			if (getters.getUpdate) {
				return await dispatch("update")
			}
			return await dispatch("insert")
		},
		async insert({ commit, getters, dispatch }) {
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, { root: true })
			let payload = await this._vm.$axios.post("/Stock/Manufacturer/Insert", getters.getIn6)
				.then(response => {
					commit('setLastUpdatedRegister', Utils.ValidateAxiosResponse(response.data));
					commit("setIn6", null)
					return true
				})
				.catch((error) => {
					dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message
					}, { root: true })
					return false
				});
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async update({ commit, getters, dispatch }) {
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, { root: true })
			let payload = await this._vm.$axios.put("/Stock/Manufacturer/Update", getters.getIn6)
				.then(response => {
					commit('setLastUpdatedRegister', Utils.ValidateAxiosResponse(response.data));
					commit("setIn6", null)
					return true
				})
				.catch((error) => {
					dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message
					}, { root: true })
					return false
				});
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async delete({ getters, dispatch }) {
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, { root: true })
			await this._vm.$axios.delete(`/Stock/Manufacturer/Delete/${getters.getIn6fabr}`)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data);
					router.push("/oryxpdv/fabricantes")
					return true
				})
				.catch((error) => {
					dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message
					}, { root: true })
					return false
				});
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
		},
		async findList({ commit, getters, dispatch }) {
			commit("setLoading", true)
			commit("initForm")
			await this._vm.$axios.get(`/Stock/Manufacturer/FindList`)
				.then(response => {
					let lstIn6 = Utils.ValidateAxiosResponse(response.data);
					commit("setLstIn6", lstIn6)
					commit("setHasNext", lstIn6.length > getters.getItemsPerPage)
				}).catch(error => {
					commit("setLstIn6", [])
					dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message
					}, { root: true })
					return false
				})
			commit("setLoading", false)
		},
		async search({ commit, getters, dispatch }, { limit = 20, page = 1 }) {
			commit("setLoading", true)
			commit("initForm")
			let payload = await this._vm.$axios.get(`/Stock/Manufacturer/Search?search=${getters.getSearch}&limit=${limit}&page=${page}`)
				.then(response => {
					let payload = Utils.ValidateAxiosResponse(response.data);
					commit("setParamsDataTable", payload)
					return true
				})
				.catch((error) => {
					commit("setLstIn6", [])
					commit("setSearch", "")
					dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message
					}, { root: true })
					return false
				});
			commit("setLoading", false)
			return payload
		},
	}
}
